import { Icon } from '@ui/themed';
import { t } from 'i18next';
import { showIntercom } from '../../../lib/intercom';
import { PARTNERS_I18N } from '../constants';

const PAGE = PARTNERS_I18N.page;

/**
 * Waitlist CTA shown in place of the toggle for partners still in closed beta.
 *
 * The `intercom-accountancy-waitlist` class is what Intercom binds the waitlist flow to, so it has
 * to stay on the button. Opening the messenger is the whole action — deliberately no navigation,
 * which would unmount the page before the messenger settles.
 */
export function PartnerBetaWaitlist() {
  return (
    <div className="hidden pl-6 text-right lg:block">
      <div className="-mb-0.5 flex items-center text-gray-500 text-xs">
        {t(`${PAGE}.beta.join`)}
      </div>
      <button
        type="button"
        className="intercom-accountancy-waitlist inline-flex cursor-pointer items-center font-medium text-indigo-600 text-xs hover:text-indigo-500"
        onClick={showIntercom}
      >
        <span>{t(`${PAGE}.beta.sign_up`)}</span>
        <Icon name="externalLink" size="sm" />
      </button>
    </div>
  );
}
